// https://www.npmjs.com/package/autolinker
import { Autolinker } from "autolinker";

export const transformTextToTextWithHyperlinks = (text) => {
    return Autolinker.link(text, { newWindow: true, sanitizeHtml: true });
};
